// --- Anchor links dropdown on mobile ---

const faqList = document.querySelector(".faq-list");
const faqSelection = document.querySelector(".faq-selection");

if (faqList && faqSelection) {
  faqList?.addEventListener("click", (e) => {
    const clickedLink = e.target.closest("a");

    if (!clickedLink) return;

    // Remove 'active' from all links in the list
    const allLinks = faqList.querySelectorAll("a");
    allLinks.forEach((link) => link.classList.remove("active"));

    // Add 'active' to the current link
    clickedLink.classList.add("active");

    // Add clickedLink text to the selection
    faqSelection.innerHTML = clickedLink.innerHTML;

    // Remove 'open' from the list and 'active' from the selection
    faqList.classList.remove("open");
    faqSelection.classList.remove("active");
  });

  // Click outside to close the dropdown
  document.addEventListener("click", (e) => {
    const isClickInside =
      faqSelection.contains(e.target) || faqList.contains(e.target);
    if (!isClickInside) {
      faqList.classList.remove("open");
      faqSelection.classList.remove("active");
    }
  });

  faqSelection.innerHTML = faqList.querySelector("a").innerHTML;

  faqSelection.addEventListener("click", function (e) {
    e.preventDefault();
    this.classList.toggle("active");
    faqList.classList.toggle("open");
  });
}
